function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "70",
  viewBox: "0 0 80 61",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1966_115485)"
}, /*#__PURE__*/React.createElement("rect", {
  x: ".5",
  y: "1.221",
  width: "37",
  height: "26.78",
  rx: ".5",
  fill: "#FAFAFA"
}), /*#__PURE__*/React.createElement("rect", {
  x: "15",
  y: "7.666",
  width: "8",
  height: "8",
  rx: "1",
  fill: "#DDE0E4"
}), /*#__PURE__*/React.createElement("rect", {
  x: "4",
  y: "18.666",
  width: "30",
  height: "2.89",
  rx: ".723",
  fill: "#DDE0E4"
}), /*#__PURE__*/React.createElement("rect", {
  x: ".5",
  y: "1.221",
  width: "37",
  height: "26.78",
  rx: ".5",
  stroke: "#DDE0E4"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip1_1966_115485)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "a",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("rect", {
  x: "42",
  y: ".721",
  width: "38",
  height: "27.78",
  rx: ".723"
})), /*#__PURE__*/React.createElement("rect", {
  x: "42",
  y: ".721",
  width: "38",
  height: "27.78",
  rx: ".723",
  fill: "#FAFAFA"
}), /*#__PURE__*/React.createElement("rect", {
  x: "57",
  y: "7.666",
  width: "8",
  height: "8",
  rx: "1",
  fill: "#DDE0E4"
}), /*#__PURE__*/React.createElement("rect", {
  x: "46",
  y: "18.666",
  width: "30",
  height: "2.89",
  rx: ".723",
  fill: "#DDE0E4"
}), /*#__PURE__*/React.createElement("rect", {
  x: "42",
  y: ".721",
  width: "38",
  height: "27.78",
  rx: ".723",
  stroke: "#DDE0E4",
  strokeWidth: "2",
  mask: "url(#a)"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip2_1966_115485)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("rect", {
  y: "32.5",
  width: "38",
  height: "27.78",
  rx: ".723"
})), /*#__PURE__*/React.createElement("rect", {
  y: "32.5",
  width: "38",
  height: "27.78",
  rx: ".723",
  fill: "#FAFAFA"
}), /*#__PURE__*/React.createElement("rect", {
  x: "15",
  y: "39.445",
  width: "8",
  height: "8",
  rx: "1",
  fill: "#DDE0E4"
}), /*#__PURE__*/React.createElement("rect", {
  x: "4",
  y: "50.445",
  width: "30",
  height: "2.89",
  rx: ".723",
  fill: "#DDE0E4"
}), /*#__PURE__*/React.createElement("rect", {
  y: "32.5",
  width: "38",
  height: "27.78",
  rx: ".723",
  stroke: "#DDE0E4",
  strokeWidth: "2",
  mask: "url(#b)"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip3_1966_115485)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "c",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("rect", {
  x: "42",
  y: "32.5",
  width: "38",
  height: "27.78",
  rx: ".723"
})), /*#__PURE__*/React.createElement("rect", {
  x: "42",
  y: "32.5",
  width: "38",
  height: "27.78",
  rx: ".723",
  fill: "#FAFAFA"
}), /*#__PURE__*/React.createElement("rect", {
  x: "57",
  y: "39.445",
  width: "8",
  height: "8",
  rx: "1",
  fill: "#DDE0E4"
}), /*#__PURE__*/React.createElement("rect", {
  x: "46",
  y: "50.445",
  width: "30",
  height: "2.89",
  rx: ".723",
  fill: "#DDE0E4"
}), /*#__PURE__*/React.createElement("rect", {
  x: "42",
  y: "32.5",
  width: "38",
  height: "27.78",
  rx: ".723",
  stroke: "#DDE0E4",
  strokeWidth: "2",
  mask: "url(#c)"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1966_115485"
}, /*#__PURE__*/React.createElement("rect", {
  y: ".721",
  width: "38",
  height: "27.78",
  rx: "1",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip1_1966_115485"
}, /*#__PURE__*/React.createElement("rect", {
  x: "42",
  y: ".721",
  width: "38",
  height: "27.78",
  rx: "1",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip2_1966_115485"
}, /*#__PURE__*/React.createElement("rect", {
  y: "32.5",
  width: "38",
  height: "27.78",
  rx: "1",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip3_1966_115485"
}, /*#__PURE__*/React.createElement("rect", {
  x: "42",
  y: "32.5",
  width: "38",
  height: "27.78",
  rx: "1",
  fill: "#fff"
})))));